const BASE_URL = process.env.REACT_APP_API_URL ?? '';

export const getRankingTable = async (pageIndex, pageSize, sorting, columnFilters) => {
  const url = new URL('/api/ranking', BASE_URL || window.location.origin);
  url.searchParams.set('page', `${pageIndex}`);
  url.searchParams.set('pageSize', `${pageSize}`);
  url.searchParams.set('sorting', JSON.stringify(sorting ?? []));
  url.searchParams.set('filters', JSON.stringify(columnFilters ?? []));

  const response = await fetch(url.href);
  return response.json();
};

export const getRankingHistory = async (jugId) => {
  const url = new URL(`/api/ranking/history/${jugId}`, BASE_URL || window.location.origin);
  const response = await fetch(url.href);
  return response.json();
};
